import React from 'react';
import SelectInput from './select_input';

export default function(props) {
  return <SelectInput {...props} />;
}
